module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore31-7bef069a447338913588734af843d12b.jpg";